import './../css/poy.less';
import ModalFramework from './components/ModalFramework';
import GrantSelection from './pages/GrantSelection';

window.d = document;

const onLoadContent = () => {
  const _modalFramework = new ModalFramework();
    const _grantSelection = new GrantSelection();
}


if (document.readyState !== "loading") {
    onLoadContent();
}


document.addEventListener("DOMContentLoaded", () => {
    onLoadContent();
});